import { render } from "./CGUPage.vue?vue&type=template&id=6537b804&scoped=true"
import script from "./CGUPage.vue?vue&type=script&lang=js"
export * from "./CGUPage.vue?vue&type=script&lang=js"

import "./CGUPage.vue?vue&type=style&index=0&id=6537b804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6537b804"]])

export default __exports__